// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IndySoft Enterprise API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ChargeTypeViewModelODataResponseViewModel } from '../models';
// @ts-ignore
import type { CompanyViewModelODataResponseViewModel } from '../models';
// @ts-ignore
import type { DepartmentViewModelODataResponseViewModel } from '../models';
// @ts-ignore
import type { EmployeeViewModelODataResponseViewModel } from '../models';
// @ts-ignore
import type { EquipmentTemplateViewModelODataResponseViewModel } from '../models';
// @ts-ignore
import type { EquipmentViewModelODataResponseViewModel } from '../models';
// @ts-ignore
import type { EstimateViewModelODataResponseViewModel } from '../models';
// @ts-ignore
import type { EventTypeViewModelODataResponseViewModel } from '../models';
// @ts-ignore
import type { LocationTreeEmployeeInventoryViewModelODataResponseViewModel } from '../models';
// @ts-ignore
import type { LocationTreeInventoryHistoryViewModelODataResponseViewModel } from '../models';
// @ts-ignore
import type { LocationTreeLocationViewModelODataResponseViewModel } from '../models';
// @ts-ignore
import type { LocationViewModelODataResponseViewModel } from '../models';
// @ts-ignore
import type { RepairPartViewModelODataResponseViewModel } from '../models';
// @ts-ignore
import type { ServiceAgreementChargeTypeViewModelODataResponseViewModel } from '../models';
// @ts-ignore
import type { ServiceSiteViewModelODataResponseViewModel } from '../models';
// @ts-ignore
import type { SubLocationViewModelODataResponseViewModel } from '../models';
// @ts-ignore
import type { TaxonomyNodeViewModelODataResponseViewModel } from '../models';
// @ts-ignore
import type { UserViewModelODataResponseViewModel } from '../models';
// @ts-ignore
import type { VendorViewModelODataResponseViewModel } from '../models';
// @ts-ignore
import type { WorkOrderViewModelODataResponseViewModel } from '../models';
// @ts-ignore
import type { WorkPriorityViewModelODataResponseViewModel } from '../models';
/**
 * IndyODataApi - axios parameter creator
 * @export
 */
export const IndyODataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataChargeTypesGet: async ($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/charge-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataCompaniesGet: async ($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary (Applies Company restrictions)
         * @param {boolean} [useDefaultCompany] 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataDepartmentsGet: async (useDefaultCompany?: boolean, $filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/departments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (useDefaultCompany !== undefined) {
                localVarQueryParameter['useDefaultCompany'] = useDefaultCompany;
            }

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary (Applies Company restrictions) Gets employees as an OData queryable endpoint.
         * @param {boolean} [useDefaultCompany] 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataEmployeesGet: async (useDefaultCompany?: boolean, $filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (useDefaultCompany !== undefined) {
                localVarQueryParameter['useDefaultCompany'] = useDefaultCompany;
            }

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary (Applies Company restrictions)
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataEquipmentGet: async ($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/equipment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets Equipment Templates as an OData queryable endpoint.
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataEquipmentTemplatesGet: async ($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/equipment-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataEstimatesGet: async ($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/estimates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataEventTypesGet: async ($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/event-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves location tree employee inventory records (checked out items).
         * @param {string} [atOrUnderFromLocationId] Optional. If provided, returns only records where FromLocation is at or under this location in the hierarchy.
         * @param {string} [atOrUnderToLocationId] Optional. If provided, returns only records where ToLocation is at or under this location in the hierarchy.
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataLocationTreeEmployeeInventoryGet: async (atOrUnderFromLocationId?: string, atOrUnderToLocationId?: string, $filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/location-tree-employee-inventory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (atOrUnderFromLocationId !== undefined) {
                localVarQueryParameter['atOrUnderFromLocationId'] = atOrUnderFromLocationId;
            }

            if (atOrUnderToLocationId !== undefined) {
                localVarQueryParameter['atOrUnderToLocationId'] = atOrUnderToLocationId;
            }

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This method will not return the full tree structure of a Location.  If you need the full tree structure, use the location-tree/{id}/tree method instead.
         * @param {boolean} [applyLocationTreeConfiguration] Whether to apply location tree configuration restrictions.
         * @param {string} [atOrUnderLocationId] Optional. If provided, returns only locations that are at or under this location in the hierarchy.
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataLocationTreeGet: async (applyLocationTreeConfiguration?: boolean, atOrUnderLocationId?: string, $filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/location-tree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (applyLocationTreeConfiguration !== undefined) {
                localVarQueryParameter['applyLocationTreeConfiguration'] = applyLocationTreeConfiguration;
            }

            if (atOrUnderLocationId !== undefined) {
                localVarQueryParameter['atOrUnderLocationId'] = atOrUnderLocationId;
            }

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves active location tree inventory history records.  Only returns records that have an associated OutEquip record (active check-outs).  Includes Location From/To with Breadcrumb, Employee From/To details, and Asset information.
         * @param {string} [atOrUnderFromLocationId] Optional. If provided, returns only records where FromLocation is at or under this location in the hierarchy.
         * @param {string} [atOrUnderToLocationId] Optional. If provided, returns only records where ToLocation is at or under this location in the hierarchy.
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataLocationTreeInventoryHistoryGet: async (atOrUnderFromLocationId?: string, atOrUnderToLocationId?: string, $filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/location-tree-inventory-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (atOrUnderFromLocationId !== undefined) {
                localVarQueryParameter['atOrUnderFromLocationId'] = atOrUnderFromLocationId;
            }

            if (atOrUnderToLocationId !== undefined) {
                localVarQueryParameter['atOrUnderToLocationId'] = atOrUnderToLocationId;
            }

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary (Applies Company restrictions) Retrieves the (legacy, Location/SubLocation) Location list.
         * @param {boolean} [useDefaultCompany] Whether to retrieve the list for the default Location Company in User Preferences.
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataLocationsGet: async (useDefaultCompany?: boolean, $filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (useDefaultCompany !== undefined) {
                localVarQueryParameter['useDefaultCompany'] = useDefaultCompany;
            }

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataRepairPartsGet: async ($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/repair-parts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataServiceAgreementChargeTypesGet: async ($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/service-agreement-charge-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataServiceSitesGet: async ($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/service-sites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary (Applies Company restrictions) Gets SubLocations (from legacy Location/SubLocations system).
         * @param {boolean} [useDefaultCompany] Whether to retrieve the list for the default Location Company in User Preferences.
         * @param {string} [locationName] Optional. The Location Name.
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataSubLocationsGet: async (useDefaultCompany?: boolean, locationName?: string, $filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/sub-locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (useDefaultCompany !== undefined) {
                localVarQueryParameter['useDefaultCompany'] = useDefaultCompany;
            }

            if (locationName !== undefined) {
                localVarQueryParameter['locationName'] = locationName;
            }

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataTaxonomyNodesGet: async ($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/taxonomy-nodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataUsersGet: async ($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary (Applies Company restrictions)
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataVendorsGet: async ($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/vendors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves a collection of work orders based on the specified query parameters.
         * @param {string} [associatedEmployeeUserName] An optional filter for the username of the employee associated with the work orders. If null, no filtering              is applied by username.
         * @param {string} [associatedEmployeeCompanyName] An optional filter for the company name of the employee associated with the work orders. If null, no              filtering is applied by company name.
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataWorkOrdersGet: async (associatedEmployeeUserName?: string, associatedEmployeeCompanyName?: string, $filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/work-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (associatedEmployeeUserName !== undefined) {
                localVarQueryParameter['associatedEmployeeUserName'] = associatedEmployeeUserName;
            }

            if (associatedEmployeeCompanyName !== undefined) {
                localVarQueryParameter['associatedEmployeeCompanyName'] = associatedEmployeeCompanyName;
            }

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataWorkPrioritiesGet: async ($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/odata/work-priorities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IndyODataApi - functional programming interface
 * @export
 */
export const IndyODataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IndyODataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataChargeTypesGet($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChargeTypeViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataChargeTypesGet($filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataChargeTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataCompaniesGet($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataCompaniesGet($filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataCompaniesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary (Applies Company restrictions)
         * @param {boolean} [useDefaultCompany] 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataDepartmentsGet(useDefaultCompany?: boolean, $filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataDepartmentsGet(useDefaultCompany, $filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataDepartmentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary (Applies Company restrictions) Gets employees as an OData queryable endpoint.
         * @param {boolean} [useDefaultCompany] 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataEmployeesGet(useDefaultCompany?: boolean, $filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataEmployeesGet(useDefaultCompany, $filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataEmployeesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary (Applies Company restrictions)
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataEquipmentGet($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EquipmentViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataEquipmentGet($filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataEquipmentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets Equipment Templates as an OData queryable endpoint.
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataEquipmentTemplatesGet($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EquipmentTemplateViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataEquipmentTemplatesGet($filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataEquipmentTemplatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataEstimatesGet($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EstimateViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataEstimatesGet($filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataEstimatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataEventTypesGet($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventTypeViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataEventTypesGet($filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataEventTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves location tree employee inventory records (checked out items).
         * @param {string} [atOrUnderFromLocationId] Optional. If provided, returns only records where FromLocation is at or under this location in the hierarchy.
         * @param {string} [atOrUnderToLocationId] Optional. If provided, returns only records where ToLocation is at or under this location in the hierarchy.
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataLocationTreeEmployeeInventoryGet(atOrUnderFromLocationId?: string, atOrUnderToLocationId?: string, $filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationTreeEmployeeInventoryViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataLocationTreeEmployeeInventoryGet(atOrUnderFromLocationId, atOrUnderToLocationId, $filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataLocationTreeEmployeeInventoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary This method will not return the full tree structure of a Location.  If you need the full tree structure, use the location-tree/{id}/tree method instead.
         * @param {boolean} [applyLocationTreeConfiguration] Whether to apply location tree configuration restrictions.
         * @param {string} [atOrUnderLocationId] Optional. If provided, returns only locations that are at or under this location in the hierarchy.
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataLocationTreeGet(applyLocationTreeConfiguration?: boolean, atOrUnderLocationId?: string, $filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationTreeLocationViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataLocationTreeGet(applyLocationTreeConfiguration, atOrUnderLocationId, $filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataLocationTreeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves active location tree inventory history records.  Only returns records that have an associated OutEquip record (active check-outs).  Includes Location From/To with Breadcrumb, Employee From/To details, and Asset information.
         * @param {string} [atOrUnderFromLocationId] Optional. If provided, returns only records where FromLocation is at or under this location in the hierarchy.
         * @param {string} [atOrUnderToLocationId] Optional. If provided, returns only records where ToLocation is at or under this location in the hierarchy.
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataLocationTreeInventoryHistoryGet(atOrUnderFromLocationId?: string, atOrUnderToLocationId?: string, $filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationTreeInventoryHistoryViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataLocationTreeInventoryHistoryGet(atOrUnderFromLocationId, atOrUnderToLocationId, $filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataLocationTreeInventoryHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary (Applies Company restrictions) Retrieves the (legacy, Location/SubLocation) Location list.
         * @param {boolean} [useDefaultCompany] Whether to retrieve the list for the default Location Company in User Preferences.
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataLocationsGet(useDefaultCompany?: boolean, $filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataLocationsGet(useDefaultCompany, $filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataLocationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataRepairPartsGet($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairPartViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataRepairPartsGet($filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataRepairPartsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataServiceAgreementChargeTypesGet($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceAgreementChargeTypeViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataServiceAgreementChargeTypesGet($filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataServiceAgreementChargeTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataServiceSitesGet($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceSiteViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataServiceSitesGet($filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataServiceSitesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary (Applies Company restrictions) Gets SubLocations (from legacy Location/SubLocations system).
         * @param {boolean} [useDefaultCompany] Whether to retrieve the list for the default Location Company in User Preferences.
         * @param {string} [locationName] Optional. The Location Name.
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataSubLocationsGet(useDefaultCompany?: boolean, locationName?: string, $filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubLocationViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataSubLocationsGet(useDefaultCompany, locationName, $filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataSubLocationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataTaxonomyNodesGet($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxonomyNodeViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataTaxonomyNodesGet($filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataTaxonomyNodesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataUsersGet($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataUsersGet($filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataUsersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary (Applies Company restrictions)
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataVendorsGet($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VendorViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataVendorsGet($filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataVendorsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves a collection of work orders based on the specified query parameters.
         * @param {string} [associatedEmployeeUserName] An optional filter for the username of the employee associated with the work orders. If null, no filtering              is applied by username.
         * @param {string} [associatedEmployeeCompanyName] An optional filter for the company name of the employee associated with the work orders. If null, no              filtering is applied by company name.
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataWorkOrdersGet(associatedEmployeeUserName?: string, associatedEmployeeCompanyName?: string, $filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataWorkOrdersGet(associatedEmployeeUserName, associatedEmployeeCompanyName, $filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataWorkOrdersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [$filter] Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
         * @param {string} [$select] Select specific properties (e.g., Name,Id)
         * @param {string} [$expand] Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
         * @param {string} [$orderby] Order results (e.g., Name desc)
         * @param {number} [$top] Limit number of results
         * @param {number} [$skip] Skip number of results
         * @param {boolean} [$count] Include total count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOdataWorkPrioritiesGet($filter?: string, $select?: string, $expand?: string, $orderby?: string, $top?: number, $skip?: number, $count?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkPriorityViewModelODataResponseViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOdataWorkPrioritiesGet($filter, $select, $expand, $orderby, $top, $skip, $count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndyODataApi.apiOdataWorkPrioritiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IndyODataApi - factory interface
 * @export
 */
export const IndyODataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IndyODataApiFp(configuration)
    return {
        /**
         * 
         * @param {IndyODataApiApiOdataChargeTypesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataChargeTypesGet(requestParameters: IndyODataApiApiOdataChargeTypesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChargeTypeViewModelODataResponseViewModel> {
            return localVarFp.apiOdataChargeTypesGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IndyODataApiApiOdataCompaniesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataCompaniesGet(requestParameters: IndyODataApiApiOdataCompaniesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CompanyViewModelODataResponseViewModel> {
            return localVarFp.apiOdataCompaniesGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary (Applies Company restrictions)
         * @param {IndyODataApiApiOdataDepartmentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataDepartmentsGet(requestParameters: IndyODataApiApiOdataDepartmentsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DepartmentViewModelODataResponseViewModel> {
            return localVarFp.apiOdataDepartmentsGet(requestParameters.useDefaultCompany, requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary (Applies Company restrictions) Gets employees as an OData queryable endpoint.
         * @param {IndyODataApiApiOdataEmployeesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataEmployeesGet(requestParameters: IndyODataApiApiOdataEmployeesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeViewModelODataResponseViewModel> {
            return localVarFp.apiOdataEmployeesGet(requestParameters.useDefaultCompany, requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary (Applies Company restrictions)
         * @param {IndyODataApiApiOdataEquipmentGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataEquipmentGet(requestParameters: IndyODataApiApiOdataEquipmentGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EquipmentViewModelODataResponseViewModel> {
            return localVarFp.apiOdataEquipmentGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets Equipment Templates as an OData queryable endpoint.
         * @param {IndyODataApiApiOdataEquipmentTemplatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataEquipmentTemplatesGet(requestParameters: IndyODataApiApiOdataEquipmentTemplatesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EquipmentTemplateViewModelODataResponseViewModel> {
            return localVarFp.apiOdataEquipmentTemplatesGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IndyODataApiApiOdataEstimatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataEstimatesGet(requestParameters: IndyODataApiApiOdataEstimatesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EstimateViewModelODataResponseViewModel> {
            return localVarFp.apiOdataEstimatesGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IndyODataApiApiOdataEventTypesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataEventTypesGet(requestParameters: IndyODataApiApiOdataEventTypesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EventTypeViewModelODataResponseViewModel> {
            return localVarFp.apiOdataEventTypesGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves location tree employee inventory records (checked out items).
         * @param {IndyODataApiApiOdataLocationTreeEmployeeInventoryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataLocationTreeEmployeeInventoryGet(requestParameters: IndyODataApiApiOdataLocationTreeEmployeeInventoryGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LocationTreeEmployeeInventoryViewModelODataResponseViewModel> {
            return localVarFp.apiOdataLocationTreeEmployeeInventoryGet(requestParameters.atOrUnderFromLocationId, requestParameters.atOrUnderToLocationId, requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This method will not return the full tree structure of a Location.  If you need the full tree structure, use the location-tree/{id}/tree method instead.
         * @param {IndyODataApiApiOdataLocationTreeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataLocationTreeGet(requestParameters: IndyODataApiApiOdataLocationTreeGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LocationTreeLocationViewModelODataResponseViewModel> {
            return localVarFp.apiOdataLocationTreeGet(requestParameters.applyLocationTreeConfiguration, requestParameters.atOrUnderLocationId, requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves active location tree inventory history records.  Only returns records that have an associated OutEquip record (active check-outs).  Includes Location From/To with Breadcrumb, Employee From/To details, and Asset information.
         * @param {IndyODataApiApiOdataLocationTreeInventoryHistoryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataLocationTreeInventoryHistoryGet(requestParameters: IndyODataApiApiOdataLocationTreeInventoryHistoryGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LocationTreeInventoryHistoryViewModelODataResponseViewModel> {
            return localVarFp.apiOdataLocationTreeInventoryHistoryGet(requestParameters.atOrUnderFromLocationId, requestParameters.atOrUnderToLocationId, requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary (Applies Company restrictions) Retrieves the (legacy, Location/SubLocation) Location list.
         * @param {IndyODataApiApiOdataLocationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataLocationsGet(requestParameters: IndyODataApiApiOdataLocationsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LocationViewModelODataResponseViewModel> {
            return localVarFp.apiOdataLocationsGet(requestParameters.useDefaultCompany, requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IndyODataApiApiOdataRepairPartsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataRepairPartsGet(requestParameters: IndyODataApiApiOdataRepairPartsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<RepairPartViewModelODataResponseViewModel> {
            return localVarFp.apiOdataRepairPartsGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IndyODataApiApiOdataServiceAgreementChargeTypesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataServiceAgreementChargeTypesGet(requestParameters: IndyODataApiApiOdataServiceAgreementChargeTypesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServiceAgreementChargeTypeViewModelODataResponseViewModel> {
            return localVarFp.apiOdataServiceAgreementChargeTypesGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IndyODataApiApiOdataServiceSitesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataServiceSitesGet(requestParameters: IndyODataApiApiOdataServiceSitesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ServiceSiteViewModelODataResponseViewModel> {
            return localVarFp.apiOdataServiceSitesGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary (Applies Company restrictions) Gets SubLocations (from legacy Location/SubLocations system).
         * @param {IndyODataApiApiOdataSubLocationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataSubLocationsGet(requestParameters: IndyODataApiApiOdataSubLocationsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SubLocationViewModelODataResponseViewModel> {
            return localVarFp.apiOdataSubLocationsGet(requestParameters.useDefaultCompany, requestParameters.locationName, requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IndyODataApiApiOdataTaxonomyNodesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataTaxonomyNodesGet(requestParameters: IndyODataApiApiOdataTaxonomyNodesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TaxonomyNodeViewModelODataResponseViewModel> {
            return localVarFp.apiOdataTaxonomyNodesGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IndyODataApiApiOdataUsersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataUsersGet(requestParameters: IndyODataApiApiOdataUsersGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserViewModelODataResponseViewModel> {
            return localVarFp.apiOdataUsersGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary (Applies Company restrictions)
         * @param {IndyODataApiApiOdataVendorsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataVendorsGet(requestParameters: IndyODataApiApiOdataVendorsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<VendorViewModelODataResponseViewModel> {
            return localVarFp.apiOdataVendorsGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves a collection of work orders based on the specified query parameters.
         * @param {IndyODataApiApiOdataWorkOrdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataWorkOrdersGet(requestParameters: IndyODataApiApiOdataWorkOrdersGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderViewModelODataResponseViewModel> {
            return localVarFp.apiOdataWorkOrdersGet(requestParameters.associatedEmployeeUserName, requestParameters.associatedEmployeeCompanyName, requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IndyODataApiApiOdataWorkPrioritiesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOdataWorkPrioritiesGet(requestParameters: IndyODataApiApiOdataWorkPrioritiesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<WorkPriorityViewModelODataResponseViewModel> {
            return localVarFp.apiOdataWorkPrioritiesGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IndyODataApi - interface
 * @export
 * @interface IndyODataApi
 */
export interface IndyODataApiInterface {
    /**
     * 
     * @param {IndyODataApiApiOdataChargeTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataChargeTypesGet(requestParameters?: IndyODataApiApiOdataChargeTypesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChargeTypeViewModelODataResponseViewModel>;

    /**
     * 
     * @param {IndyODataApiApiOdataCompaniesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataCompaniesGet(requestParameters?: IndyODataApiApiOdataCompaniesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompanyViewModelODataResponseViewModel>;

    /**
     * 
     * @summary (Applies Company restrictions)
     * @param {IndyODataApiApiOdataDepartmentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataDepartmentsGet(requestParameters?: IndyODataApiApiOdataDepartmentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DepartmentViewModelODataResponseViewModel>;

    /**
     * 
     * @summary (Applies Company restrictions) Gets employees as an OData queryable endpoint.
     * @param {IndyODataApiApiOdataEmployeesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataEmployeesGet(requestParameters?: IndyODataApiApiOdataEmployeesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeViewModelODataResponseViewModel>;

    /**
     * 
     * @summary (Applies Company restrictions)
     * @param {IndyODataApiApiOdataEquipmentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataEquipmentGet(requestParameters?: IndyODataApiApiOdataEquipmentGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EquipmentViewModelODataResponseViewModel>;

    /**
     * 
     * @summary Gets Equipment Templates as an OData queryable endpoint.
     * @param {IndyODataApiApiOdataEquipmentTemplatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataEquipmentTemplatesGet(requestParameters?: IndyODataApiApiOdataEquipmentTemplatesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EquipmentTemplateViewModelODataResponseViewModel>;

    /**
     * 
     * @param {IndyODataApiApiOdataEstimatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataEstimatesGet(requestParameters?: IndyODataApiApiOdataEstimatesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EstimateViewModelODataResponseViewModel>;

    /**
     * 
     * @param {IndyODataApiApiOdataEventTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataEventTypesGet(requestParameters?: IndyODataApiApiOdataEventTypesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EventTypeViewModelODataResponseViewModel>;

    /**
     * 
     * @summary Retrieves location tree employee inventory records (checked out items).
     * @param {IndyODataApiApiOdataLocationTreeEmployeeInventoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataLocationTreeEmployeeInventoryGet(requestParameters?: IndyODataApiApiOdataLocationTreeEmployeeInventoryGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<LocationTreeEmployeeInventoryViewModelODataResponseViewModel>;

    /**
     * 
     * @summary This method will not return the full tree structure of a Location.  If you need the full tree structure, use the location-tree/{id}/tree method instead.
     * @param {IndyODataApiApiOdataLocationTreeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataLocationTreeGet(requestParameters?: IndyODataApiApiOdataLocationTreeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<LocationTreeLocationViewModelODataResponseViewModel>;

    /**
     * 
     * @summary Retrieves active location tree inventory history records.  Only returns records that have an associated OutEquip record (active check-outs).  Includes Location From/To with Breadcrumb, Employee From/To details, and Asset information.
     * @param {IndyODataApiApiOdataLocationTreeInventoryHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataLocationTreeInventoryHistoryGet(requestParameters?: IndyODataApiApiOdataLocationTreeInventoryHistoryGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<LocationTreeInventoryHistoryViewModelODataResponseViewModel>;

    /**
     * 
     * @summary (Applies Company restrictions) Retrieves the (legacy, Location/SubLocation) Location list.
     * @param {IndyODataApiApiOdataLocationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataLocationsGet(requestParameters?: IndyODataApiApiOdataLocationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<LocationViewModelODataResponseViewModel>;

    /**
     * 
     * @param {IndyODataApiApiOdataRepairPartsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataRepairPartsGet(requestParameters?: IndyODataApiApiOdataRepairPartsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairPartViewModelODataResponseViewModel>;

    /**
     * 
     * @param {IndyODataApiApiOdataServiceAgreementChargeTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataServiceAgreementChargeTypesGet(requestParameters?: IndyODataApiApiOdataServiceAgreementChargeTypesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceAgreementChargeTypeViewModelODataResponseViewModel>;

    /**
     * 
     * @param {IndyODataApiApiOdataServiceSitesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataServiceSitesGet(requestParameters?: IndyODataApiApiOdataServiceSitesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceSiteViewModelODataResponseViewModel>;

    /**
     * 
     * @summary (Applies Company restrictions) Gets SubLocations (from legacy Location/SubLocations system).
     * @param {IndyODataApiApiOdataSubLocationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataSubLocationsGet(requestParameters?: IndyODataApiApiOdataSubLocationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubLocationViewModelODataResponseViewModel>;

    /**
     * 
     * @param {IndyODataApiApiOdataTaxonomyNodesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataTaxonomyNodesGet(requestParameters?: IndyODataApiApiOdataTaxonomyNodesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxonomyNodeViewModelODataResponseViewModel>;

    /**
     * 
     * @param {IndyODataApiApiOdataUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataUsersGet(requestParameters?: IndyODataApiApiOdataUsersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserViewModelODataResponseViewModel>;

    /**
     * 
     * @summary (Applies Company restrictions)
     * @param {IndyODataApiApiOdataVendorsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataVendorsGet(requestParameters?: IndyODataApiApiOdataVendorsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VendorViewModelODataResponseViewModel>;

    /**
     * 
     * @summary Retrieves a collection of work orders based on the specified query parameters.
     * @param {IndyODataApiApiOdataWorkOrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataWorkOrdersGet(requestParameters?: IndyODataApiApiOdataWorkOrdersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderViewModelODataResponseViewModel>;

    /**
     * 
     * @param {IndyODataApiApiOdataWorkPrioritiesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApiInterface
     */
    apiOdataWorkPrioritiesGet(requestParameters?: IndyODataApiApiOdataWorkPrioritiesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkPriorityViewModelODataResponseViewModel>;

}

/**
 * Request parameters for apiOdataChargeTypesGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataChargeTypesGetRequest
 */
export interface IndyODataApiApiOdataChargeTypesGetRequest {
    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataChargeTypesGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataChargeTypesGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataChargeTypesGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataChargeTypesGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataChargeTypesGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataChargeTypesGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataChargeTypesGet
     */
    readonly $count?: boolean
}

/**
 * Request parameters for apiOdataCompaniesGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataCompaniesGetRequest
 */
export interface IndyODataApiApiOdataCompaniesGetRequest {
    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataCompaniesGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataCompaniesGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataCompaniesGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataCompaniesGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataCompaniesGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataCompaniesGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataCompaniesGet
     */
    readonly $count?: boolean
}

/**
 * Request parameters for apiOdataDepartmentsGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataDepartmentsGetRequest
 */
export interface IndyODataApiApiOdataDepartmentsGetRequest {
    /**
     * 
     * @type {boolean}
     * @memberof IndyODataApiApiOdataDepartmentsGet
     */
    readonly useDefaultCompany?: boolean

    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataDepartmentsGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataDepartmentsGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataDepartmentsGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataDepartmentsGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataDepartmentsGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataDepartmentsGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataDepartmentsGet
     */
    readonly $count?: boolean
}

/**
 * Request parameters for apiOdataEmployeesGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataEmployeesGetRequest
 */
export interface IndyODataApiApiOdataEmployeesGetRequest {
    /**
     * 
     * @type {boolean}
     * @memberof IndyODataApiApiOdataEmployeesGet
     */
    readonly useDefaultCompany?: boolean

    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataEmployeesGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataEmployeesGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataEmployeesGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataEmployeesGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataEmployeesGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataEmployeesGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataEmployeesGet
     */
    readonly $count?: boolean
}

/**
 * Request parameters for apiOdataEquipmentGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataEquipmentGetRequest
 */
export interface IndyODataApiApiOdataEquipmentGetRequest {
    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataEquipmentGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataEquipmentGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataEquipmentGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataEquipmentGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataEquipmentGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataEquipmentGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataEquipmentGet
     */
    readonly $count?: boolean
}

/**
 * Request parameters for apiOdataEquipmentTemplatesGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataEquipmentTemplatesGetRequest
 */
export interface IndyODataApiApiOdataEquipmentTemplatesGetRequest {
    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataEquipmentTemplatesGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataEquipmentTemplatesGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataEquipmentTemplatesGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataEquipmentTemplatesGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataEquipmentTemplatesGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataEquipmentTemplatesGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataEquipmentTemplatesGet
     */
    readonly $count?: boolean
}

/**
 * Request parameters for apiOdataEstimatesGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataEstimatesGetRequest
 */
export interface IndyODataApiApiOdataEstimatesGetRequest {
    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataEstimatesGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataEstimatesGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataEstimatesGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataEstimatesGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataEstimatesGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataEstimatesGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataEstimatesGet
     */
    readonly $count?: boolean
}

/**
 * Request parameters for apiOdataEventTypesGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataEventTypesGetRequest
 */
export interface IndyODataApiApiOdataEventTypesGetRequest {
    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataEventTypesGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataEventTypesGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataEventTypesGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataEventTypesGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataEventTypesGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataEventTypesGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataEventTypesGet
     */
    readonly $count?: boolean
}

/**
 * Request parameters for apiOdataLocationTreeEmployeeInventoryGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataLocationTreeEmployeeInventoryGetRequest
 */
export interface IndyODataApiApiOdataLocationTreeEmployeeInventoryGetRequest {
    /**
     * Optional. If provided, returns only records where FromLocation is at or under this location in the hierarchy.
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationTreeEmployeeInventoryGet
     */
    readonly atOrUnderFromLocationId?: string

    /**
     * Optional. If provided, returns only records where ToLocation is at or under this location in the hierarchy.
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationTreeEmployeeInventoryGet
     */
    readonly atOrUnderToLocationId?: string

    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationTreeEmployeeInventoryGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationTreeEmployeeInventoryGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationTreeEmployeeInventoryGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationTreeEmployeeInventoryGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataLocationTreeEmployeeInventoryGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataLocationTreeEmployeeInventoryGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataLocationTreeEmployeeInventoryGet
     */
    readonly $count?: boolean
}

/**
 * Request parameters for apiOdataLocationTreeGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataLocationTreeGetRequest
 */
export interface IndyODataApiApiOdataLocationTreeGetRequest {
    /**
     * Whether to apply location tree configuration restrictions.
     * @type {boolean}
     * @memberof IndyODataApiApiOdataLocationTreeGet
     */
    readonly applyLocationTreeConfiguration?: boolean

    /**
     * Optional. If provided, returns only locations that are at or under this location in the hierarchy.
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationTreeGet
     */
    readonly atOrUnderLocationId?: string

    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationTreeGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationTreeGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationTreeGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationTreeGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataLocationTreeGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataLocationTreeGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataLocationTreeGet
     */
    readonly $count?: boolean
}

/**
 * Request parameters for apiOdataLocationTreeInventoryHistoryGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataLocationTreeInventoryHistoryGetRequest
 */
export interface IndyODataApiApiOdataLocationTreeInventoryHistoryGetRequest {
    /**
     * Optional. If provided, returns only records where FromLocation is at or under this location in the hierarchy.
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationTreeInventoryHistoryGet
     */
    readonly atOrUnderFromLocationId?: string

    /**
     * Optional. If provided, returns only records where ToLocation is at or under this location in the hierarchy.
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationTreeInventoryHistoryGet
     */
    readonly atOrUnderToLocationId?: string

    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationTreeInventoryHistoryGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationTreeInventoryHistoryGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationTreeInventoryHistoryGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationTreeInventoryHistoryGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataLocationTreeInventoryHistoryGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataLocationTreeInventoryHistoryGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataLocationTreeInventoryHistoryGet
     */
    readonly $count?: boolean
}

/**
 * Request parameters for apiOdataLocationsGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataLocationsGetRequest
 */
export interface IndyODataApiApiOdataLocationsGetRequest {
    /**
     * Whether to retrieve the list for the default Location Company in User Preferences.
     * @type {boolean}
     * @memberof IndyODataApiApiOdataLocationsGet
     */
    readonly useDefaultCompany?: boolean

    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationsGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationsGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationsGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataLocationsGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataLocationsGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataLocationsGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataLocationsGet
     */
    readonly $count?: boolean
}

/**
 * Request parameters for apiOdataRepairPartsGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataRepairPartsGetRequest
 */
export interface IndyODataApiApiOdataRepairPartsGetRequest {
    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataRepairPartsGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataRepairPartsGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataRepairPartsGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataRepairPartsGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataRepairPartsGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataRepairPartsGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataRepairPartsGet
     */
    readonly $count?: boolean
}

/**
 * Request parameters for apiOdataServiceAgreementChargeTypesGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataServiceAgreementChargeTypesGetRequest
 */
export interface IndyODataApiApiOdataServiceAgreementChargeTypesGetRequest {
    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataServiceAgreementChargeTypesGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataServiceAgreementChargeTypesGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataServiceAgreementChargeTypesGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataServiceAgreementChargeTypesGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataServiceAgreementChargeTypesGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataServiceAgreementChargeTypesGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataServiceAgreementChargeTypesGet
     */
    readonly $count?: boolean
}

/**
 * Request parameters for apiOdataServiceSitesGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataServiceSitesGetRequest
 */
export interface IndyODataApiApiOdataServiceSitesGetRequest {
    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataServiceSitesGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataServiceSitesGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataServiceSitesGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataServiceSitesGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataServiceSitesGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataServiceSitesGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataServiceSitesGet
     */
    readonly $count?: boolean
}

/**
 * Request parameters for apiOdataSubLocationsGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataSubLocationsGetRequest
 */
export interface IndyODataApiApiOdataSubLocationsGetRequest {
    /**
     * Whether to retrieve the list for the default Location Company in User Preferences.
     * @type {boolean}
     * @memberof IndyODataApiApiOdataSubLocationsGet
     */
    readonly useDefaultCompany?: boolean

    /**
     * Optional. The Location Name.
     * @type {string}
     * @memberof IndyODataApiApiOdataSubLocationsGet
     */
    readonly locationName?: string

    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataSubLocationsGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataSubLocationsGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataSubLocationsGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataSubLocationsGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataSubLocationsGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataSubLocationsGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataSubLocationsGet
     */
    readonly $count?: boolean
}

/**
 * Request parameters for apiOdataTaxonomyNodesGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataTaxonomyNodesGetRequest
 */
export interface IndyODataApiApiOdataTaxonomyNodesGetRequest {
    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataTaxonomyNodesGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataTaxonomyNodesGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataTaxonomyNodesGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataTaxonomyNodesGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataTaxonomyNodesGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataTaxonomyNodesGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataTaxonomyNodesGet
     */
    readonly $count?: boolean
}

/**
 * Request parameters for apiOdataUsersGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataUsersGetRequest
 */
export interface IndyODataApiApiOdataUsersGetRequest {
    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataUsersGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataUsersGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataUsersGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataUsersGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataUsersGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataUsersGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataUsersGet
     */
    readonly $count?: boolean
}

/**
 * Request parameters for apiOdataVendorsGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataVendorsGetRequest
 */
export interface IndyODataApiApiOdataVendorsGetRequest {
    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataVendorsGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataVendorsGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataVendorsGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataVendorsGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataVendorsGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataVendorsGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataVendorsGet
     */
    readonly $count?: boolean
}

/**
 * Request parameters for apiOdataWorkOrdersGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataWorkOrdersGetRequest
 */
export interface IndyODataApiApiOdataWorkOrdersGetRequest {
    /**
     * An optional filter for the username of the employee associated with the work orders. If null, no filtering              is applied by username.
     * @type {string}
     * @memberof IndyODataApiApiOdataWorkOrdersGet
     */
    readonly associatedEmployeeUserName?: string

    /**
     * An optional filter for the company name of the employee associated with the work orders. If null, no              filtering is applied by company name.
     * @type {string}
     * @memberof IndyODataApiApiOdataWorkOrdersGet
     */
    readonly associatedEmployeeCompanyName?: string

    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataWorkOrdersGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataWorkOrdersGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataWorkOrdersGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataWorkOrdersGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataWorkOrdersGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataWorkOrdersGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataWorkOrdersGet
     */
    readonly $count?: boolean
}

/**
 * Request parameters for apiOdataWorkPrioritiesGet operation in IndyODataApi.
 * @export
 * @interface IndyODataApiApiOdataWorkPrioritiesGetRequest
 */
export interface IndyODataApiApiOdataWorkPrioritiesGetRequest {
    /**
     * Filter the results using OData syntax (e.g., Name eq \&#39;value\&#39;)
     * @type {string}
     * @memberof IndyODataApiApiOdataWorkPrioritiesGet
     */
    readonly $filter?: string

    /**
     * Select specific properties (e.g., Name,Id)
     * @type {string}
     * @memberof IndyODataApiApiOdataWorkPrioritiesGet
     */
    readonly $select?: string

    /**
     * Expand to return related entitiey properties in the viewModel (e.g., NavigationProperty)
     * @type {string}
     * @memberof IndyODataApiApiOdataWorkPrioritiesGet
     */
    readonly $expand?: string

    /**
     * Order results (e.g., Name desc)
     * @type {string}
     * @memberof IndyODataApiApiOdataWorkPrioritiesGet
     */
    readonly $orderby?: string

    /**
     * Limit number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataWorkPrioritiesGet
     */
    readonly $top?: number

    /**
     * Skip number of results
     * @type {number}
     * @memberof IndyODataApiApiOdataWorkPrioritiesGet
     */
    readonly $skip?: number

    /**
     * Include total count
     * @type {boolean}
     * @memberof IndyODataApiApiOdataWorkPrioritiesGet
     */
    readonly $count?: boolean
}

/**
 * IndyODataApi - object-oriented interface
 * @export
 * @class IndyODataApi
 * @extends {BaseAPI}
 */
export class IndyODataApi extends BaseAPI implements IndyODataApiInterface {
    /**
     * 
     * @param {IndyODataApiApiOdataChargeTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataChargeTypesGet(requestParameters: IndyODataApiApiOdataChargeTypesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataChargeTypesGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IndyODataApiApiOdataCompaniesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataCompaniesGet(requestParameters: IndyODataApiApiOdataCompaniesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataCompaniesGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary (Applies Company restrictions)
     * @param {IndyODataApiApiOdataDepartmentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataDepartmentsGet(requestParameters: IndyODataApiApiOdataDepartmentsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataDepartmentsGet(requestParameters.useDefaultCompany, requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary (Applies Company restrictions) Gets employees as an OData queryable endpoint.
     * @param {IndyODataApiApiOdataEmployeesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataEmployeesGet(requestParameters: IndyODataApiApiOdataEmployeesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataEmployeesGet(requestParameters.useDefaultCompany, requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary (Applies Company restrictions)
     * @param {IndyODataApiApiOdataEquipmentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataEquipmentGet(requestParameters: IndyODataApiApiOdataEquipmentGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataEquipmentGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets Equipment Templates as an OData queryable endpoint.
     * @param {IndyODataApiApiOdataEquipmentTemplatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataEquipmentTemplatesGet(requestParameters: IndyODataApiApiOdataEquipmentTemplatesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataEquipmentTemplatesGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IndyODataApiApiOdataEstimatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataEstimatesGet(requestParameters: IndyODataApiApiOdataEstimatesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataEstimatesGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IndyODataApiApiOdataEventTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataEventTypesGet(requestParameters: IndyODataApiApiOdataEventTypesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataEventTypesGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves location tree employee inventory records (checked out items).
     * @param {IndyODataApiApiOdataLocationTreeEmployeeInventoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataLocationTreeEmployeeInventoryGet(requestParameters: IndyODataApiApiOdataLocationTreeEmployeeInventoryGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataLocationTreeEmployeeInventoryGet(requestParameters.atOrUnderFromLocationId, requestParameters.atOrUnderToLocationId, requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This method will not return the full tree structure of a Location.  If you need the full tree structure, use the location-tree/{id}/tree method instead.
     * @param {IndyODataApiApiOdataLocationTreeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataLocationTreeGet(requestParameters: IndyODataApiApiOdataLocationTreeGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataLocationTreeGet(requestParameters.applyLocationTreeConfiguration, requestParameters.atOrUnderLocationId, requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves active location tree inventory history records.  Only returns records that have an associated OutEquip record (active check-outs).  Includes Location From/To with Breadcrumb, Employee From/To details, and Asset information.
     * @param {IndyODataApiApiOdataLocationTreeInventoryHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataLocationTreeInventoryHistoryGet(requestParameters: IndyODataApiApiOdataLocationTreeInventoryHistoryGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataLocationTreeInventoryHistoryGet(requestParameters.atOrUnderFromLocationId, requestParameters.atOrUnderToLocationId, requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary (Applies Company restrictions) Retrieves the (legacy, Location/SubLocation) Location list.
     * @param {IndyODataApiApiOdataLocationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataLocationsGet(requestParameters: IndyODataApiApiOdataLocationsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataLocationsGet(requestParameters.useDefaultCompany, requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IndyODataApiApiOdataRepairPartsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataRepairPartsGet(requestParameters: IndyODataApiApiOdataRepairPartsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataRepairPartsGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IndyODataApiApiOdataServiceAgreementChargeTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataServiceAgreementChargeTypesGet(requestParameters: IndyODataApiApiOdataServiceAgreementChargeTypesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataServiceAgreementChargeTypesGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IndyODataApiApiOdataServiceSitesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataServiceSitesGet(requestParameters: IndyODataApiApiOdataServiceSitesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataServiceSitesGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary (Applies Company restrictions) Gets SubLocations (from legacy Location/SubLocations system).
     * @param {IndyODataApiApiOdataSubLocationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataSubLocationsGet(requestParameters: IndyODataApiApiOdataSubLocationsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataSubLocationsGet(requestParameters.useDefaultCompany, requestParameters.locationName, requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IndyODataApiApiOdataTaxonomyNodesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataTaxonomyNodesGet(requestParameters: IndyODataApiApiOdataTaxonomyNodesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataTaxonomyNodesGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IndyODataApiApiOdataUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataUsersGet(requestParameters: IndyODataApiApiOdataUsersGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataUsersGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary (Applies Company restrictions)
     * @param {IndyODataApiApiOdataVendorsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataVendorsGet(requestParameters: IndyODataApiApiOdataVendorsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataVendorsGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves a collection of work orders based on the specified query parameters.
     * @param {IndyODataApiApiOdataWorkOrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataWorkOrdersGet(requestParameters: IndyODataApiApiOdataWorkOrdersGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataWorkOrdersGet(requestParameters.associatedEmployeeUserName, requestParameters.associatedEmployeeCompanyName, requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IndyODataApiApiOdataWorkPrioritiesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndyODataApi
     */
    public apiOdataWorkPrioritiesGet(requestParameters: IndyODataApiApiOdataWorkPrioritiesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return IndyODataApiFp(this.configuration).apiOdataWorkPrioritiesGet(requestParameters.$filter, requestParameters.$select, requestParameters.$expand, requestParameters.$orderby, requestParameters.$top, requestParameters.$skip, requestParameters.$count, options).then((request) => request(this.axios, this.basePath));
    }
}

